import { getEcommerceByIds, addToWishlistEvent } from "@src/analytics";
import updateHeaderShortlistCount from "@src/containers/components/Header/shortlist";
import { getPageCategory } from "@src/utils/helper";

function getFavoriteListKey(pageCategory?: string): string {
  const category = pageCategory || getPageCategory() || "apartment"; // default to apartment
  const suffix = category === "apartment" ? "" : `_${category}`;
  return `favorite_list${suffix}`;
}

export function addFavoriteItem(id: string, type?: string): void {
  const list: string[] = getFavoriteList(type);
  if (!list.includes(id)) {
    list.push(id);
    localStorage?.setItem(getFavoriteListKey(type), JSON.stringify(list));
    updateHeaderShortlistCount();
    // GTM push `add_to_wishlist` event
    getEcommerceByIds([id]).then((ecommerce) => {
      addToWishlistEvent(ecommerce);
    });
  }
}

export function removeFavoriteItem(id: string, type?: string): void {
  const list: string[] = getFavoriteList(type);
  const index: number = list.indexOf(id);
  if (index > -1) {
    list.splice(index, 1);
    localStorage?.setItem(getFavoriteListKey(type), JSON.stringify(list));
    updateHeaderShortlistCount();
  }
}

export function getFavoriteList(type?: string): string[] {
  return JSON.parse(localStorage?.getItem(getFavoriteListKey(type)) || "[]");
}

export function isFavorite(id: string, type?: string): boolean {
  const list = getFavoriteList(type);
  return list.includes(id);
}

export function getFavoriteCount(type?: string): number {
  const list = getFavoriteList(type);
  return list.length;
}

export function toggleFavorite(targetElement: Element | null) {
  const propertyId = targetElement?.getAttribute("data-property-id");

  if (propertyId) {
    if (targetElement?.getAttribute("data-favorite") === "true") {
      // remove from favorite
      targetElement?.setAttribute("data-favorite", "false");
      removeFavoriteItem(propertyId);
    } else {
      // add to favorite
      targetElement?.setAttribute("data-favorite", "true");
      addFavoriteItem(propertyId);
    }
  }
}
